module.exports = "/_next/static/images/microsalts_footer_banner-586de16962a0b16c1f65fc8977bff7ae.png";